import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

import { ButtonModule } from 'primeng/button';

// Composants
import { PageBaseComponent } from 'src/app/@shared/components/abstract/page-base.component';
import { LoadingComponent } from '../loading/loading.component';
import { OrganizationsListComponent } from '../../components/organizations/organizations-list/organizations-list.component';

// Modèles
import { Client } from 'src/app/@shared/models/client/client.model';

@Component({
    selector: 'app-home',
    imports: [
        CommonModule,
        ButtonModule,
        LoadingComponent,
        OrganizationsListComponent,
    ],
    templateUrl: './home.component.html',
    styleUrl: './home.component.scss'
})
export class HomeComponent extends PageBaseComponent {

    /*----------------------------------------------------------------------------------------
     * Gestion de la vue
     ----------------------------------------------------------------------------------------*/

    public showContent: boolean = false;

    /*----------------------------------------------------------------------------------------
     * Données
     ----------------------------------------------------------------------------------------*/

    private _clients: Client[] = [];
    public get clients(): Client[] {
        return this._clients;
    }
    public set clients(value: Client[]) {
        let emptyArray: Client[] = [];
        this._clients = emptyArray.concat(value);
    }

    /*----------------------------------------------------------------------------------------
     * Méthodes publiques
     ----------------------------------------------------------------------------------------*/

    public onClickClient(client: Client): void {
        this._openClient(client);
    }

    public onClickCreateOrganization(): void {
        this._createNewClient();
    }

    /*----------------------------------------------------------------------------------------
     * Méthodes protégées
     ----------------------------------------------------------------------------------------*/

    protected override subscribeToObservables(): void {
        // Organisations visibles par l'utilisateur
        this.subscriptions.add(
            this.appService.clientsLoaded$.subscribe((clients: Client[] | null) => {
                if (!clients) return;
                this.clients = clients;
                this.showContent = true;
                this._autoOpenSingleClient();
            })
        );
    }

    /*----------------------------------------------------------------------------------------
     * Méthodes privées
     ----------------------------------------------------------------------------------------*/

    /**
     * Un seul dossier : le sélecteur n'a rien à faire choisir (#173, décision 4).
     * La création d'une société reste accessible depuis le sélecteur du bandeau.
     */
    private _autoOpenSingleClient(): void {
        if (this.clients.length !== 1) return;
        this._openClient(this.clients[0]);
    }

    private _createNewClient(): void {
        // Déselection du client actuellement sélectionné
        this.appService.selectedClient = null;
        this.clientService.select(new Client({}), false);
        // Navigation vers le formulaire de création d'un nouveau client
        this.router.navigate(['/client/new']);
    }

    /**
     * Écran visé par une ancienne URL sans dossier (#173, décision 7). Validé pour
     * n'accepter qu'un chemin interne : sans quoi un lien forgé
     * (`/home?next=//exemple.com`) transformerait le sélecteur en redirection ouverte.
     */
    private _nextPath(): string {
        const next = this.route.snapshot.queryParamMap.get('next');
        const isInternalPath = !!next && next.startsWith('/') && !next.startsWith('//') && !next.includes('\\');
        return isInternalPath ? next : '/dashboard';
    }

    private _openClient(client: Client): void {
        this.appService.navToClient(client.id, this._nextPath());
    }

}
